import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import React from 'react'
import { WizTableForm } from '../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
import moment from "moment";
//配置项
let componentName = 'dealerNewPersonTrain'


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "经销商名称",
    name: "name",
    tableItem: {
      width: 280
    },
    searchItem: {
    }
  },
  // {
  //   title: "经销商简称",
  //   name: "shortName",
  //   tableItem: {
  //     width: 100
  //   },
  // },
  {
    title: '销售代码',
    name: 'preSalesNumber',
    searchItem: {},
    tableItem: { width: 100 }
  },
  {
    title: '售后代码',
    name: 'afterSalesNumber',
    searchItem: {},
    tableItem: { width: 100 }
  },

  {
    title: '站点类型',
    name: 'dealerType',
    dict: [
      { code: 1, codeName: '4S网点' },
      { code: 2, codeName: '直营店' },
      { code: 3, codeName: '单一售后' },
      { code: 4, codeName: '单一销售' },
      { code: 5, codeName: '卫星店/直营店' },
      { code: 6, codeName: '自修站' },
      { code: 7, codeName: '卫星店' },
      { code: 8, codeName: '精品店' },
      { code: 9, codeName: 'dealer' },
      { code: 10, codeName: '4S店' },
      { code: 11, codeName: '汽车零售' },
      { code: 12, codeName: '单一销售展厅' },
      { code: 13, codeName: 'NEV单一售后' },
      { code: 14, codeName: '轻量化4S网点' },
      { code: 15, codeName: 'NEV专区' },
      { code: 16, codeName: '商超店' },
      { code: 17, codeName: '自修店' },
      { code: 18, codeName: '二级网点' },
      { code: 19, codeName: '车工坊C1' },
      { code: 20, codeName: '车工坊C2' },
      { code: 21, codeName: '车工坊B' },
      { code: 22, codeName: '德科品牌授权经销商' },
      { code: 99, codeName: '暂定' },
      { code: 0, codeName: '无' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 120
    }
  },
  {
    title: "NEV类型",
    name: "nevType",
    dataIndex: "nevType",
    tableItem: { width: 180 },
    dict: [
      { code: 0, codeName: "无" },
      { code: 1, codeName: "专区" },
      { code: 2, codeName: "商超" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "开店状态",
    name: "status",
    dataIndex: "status",
    dict: [
      { code: 2, codeName: "建设中" },
      { code: 1, codeName: "已开店" },
      { code: 0, codeName: "已关店" },
    ],
    searchItem: { type: 'select' },
    tableItem: {
      width: 80
    }
  },
  {
    title: '开店时间',
    name: 'openTime',
    tableItem: {
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: "新店/老店",
    name: "oldNewShop",
    dataIndex: "oldNewShop",
    dict: [
      { code: 0, codeName: "新店" },
      { code: 1, codeName: "老店" },
    ],
    searchItem: { type: 'select' },
    tableItem: {
      width: 80
    }
  },
  {
    title: "新开业标识",
    name: "isNewOpening",
    dataIndex: "isNewOpening",
    dict: [
      { code: 1, codeName: "是" },
      { code: 0, codeName: "否" },
    ],
    searchItem: { type: 'select' },
    tableItem: {
      width: 100
    }
  },
  {
    title: "DP状态未确认",
    name: "dpStatus",
    dataIndex: "dpStatus",
    dict: [
      { code: 0, codeName: "无" },
      { code: 1, codeName: "有" },
    ],
    searchItem: {
      type: "select"
    },
  },
  {
    title: "DP状态未确认人数",
    name: "dpNum",
    dataIndex: "dpNum",
    tableItem: {},
  },
  {
    title: '系统合格时间',
    name: 'sysPassTime',
    tableItem: {
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: '系统合格时间',
    name: 'sysPassDate',
    dataIndex: "sysPassDate",
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    },
  },
];

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.sysPassDate && value.sysPassDate.length === 2) {
              value.sysPassStartTime = moment(value.sysPassDate[0]).format('YYYY-MM-DD 00:00:00')
              value.sysPassEndTime = moment(value.sysPassDate[1]).format('YYYY-MM-DD 23:59:59')
            } else {
              value.sysPassStartTime = undefined;
              value.sysPassEndTime = undefined;
            }
            return value
          },
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          collapse: false,
          buttonSort: ['export', 'exportTypeReport', 'batchImportDPState', 'exportByDealerType'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportTypeReport',
              custom: true,
              params: { icon: 'export', children: '新开业人员培训详情导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportTypeReport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'batchImportDPState',
              custom: true,
              params: { icon: 'batchImportDPState', children: 'DP状态导入', type: 'import'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/dealerNewPersonTrain/dealerNewPersonTrainList/batchImportDPState',
                }
              }
            },
            {
              key: 'exportByDealerType',
              custom: true,
              params: { icon: 'export', children: '根据站点类型导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportByDealerType",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        // showAuth: {
        //   title: '适用范围',
        //   dataIndex: 'authData'
        // },
        rowOperateSort: ['lookRequirementPersonnelDetailList', 'lookTrainDetail', 'requirementPersonnelApply'],
        rowOperateView: [
          {
            key: "lookTrainDetail",
            // custom: true,
            name: 'WizButton',
            params: { children: "当前培训查看", tooltip: "查看目前该门店人员的实时培训情况" },
            onClick: ({ record }) => {
              /**
               * 因详情页可在面包屑未关闭时多次进入,会出现搜索条件覆盖问题,在每次进入时需手动清除下详情页的搜索内容
               * 将需要重置页面的路由地址从searchMap中剔除,进行重置后再进行跳转
               */
              let value = JSON.parse(sessionStorage.getItem('searchMap'));
              let filterSearch = value.filter(item => item.key !== '#/dealerNewPersonTrain/dealerNewPersonTrainList/dealerNewPersonTrainDetailList')
              sessionStorage.setItem('searchMap', JSON.stringify(filterSearch))
              self.jumpPage('push', '/dealerNewPersonTrain/dealerNewPersonTrainList/dealerNewPersonTrainDetailList', record)
            }
            // customOnClick: {
            //   key: "jumpPage",
            //   params: {
            //     key: "push",
            //     //pathname: "/requirementPersonnel/requirementPersonnelList/requirementPersonnelDetailList"
            //     pathname: "/dealerNewPersonTrain/dealerNewPersonTrainList/dealerNewPersonTrainDetailList"
            //   }
            // }
          },
          // {
          //   key: "lookRequirementPersonnelDetailList",
          //   custom: true,
          //   params: { children: "新开业培训查看", tooltip: "查看门店整个新开业流程的培训情况" },
          //   customOnClick: {
          //     key: "jumpPage",
          //     params: {
          //       key: "push",
          //       pathname: "/dealerNewPersonTrain/dealerNewPersonTrainList/requirementPersonnelDetailList"
          //     },
          //     formatParams: (rows, record, filters, callback) => {
          //       let requirementPersonnelEntity = record && record.requirementPersonnelEntity;
          //       log.info('requirementPersonnelEntity', requirementPersonnelEntity);
          //       return { record: { ...requirementPersonnelEntity } }
          //     }
          //   },
          //   recordChangeParams: ({ record, rows }) => {
          //     return { hidden: !(record.isNewOpening === 1) }
          //   }
          // },
          {
            key: "enable",
            custom: true,
            params: { children: "设为老店" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const info = <font color='red'>{record.name}</font>
                const content = <div>您正在将{info}的“新店/老店”标识由“新店”设置为“老店”，此操作不可逆，操作成功后该经销商新加入的学员将以老店新人的考核要求进行培训，是否确认？</div>
                WizModal.confirm({
                  title: '信息确认',
                  content: content,
                  width: 500,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      oldNewShop: 1
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return { hidden: !(record.oldNewShop === 0 && record.status == 1) }
            }
          },
          {
            key: "requirementPersonnelApply",
            custom: true,
            params: { children: "测评报名管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/dealerNewPersonTrain/dealerNewPersonTrainList/apply"
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let dealerType = record && record.dealerType;
              let disabled = false;
              if (14 === dealerType) {
                disabled = true;
              }
              return { hidden: !(record.isNewOpening === 1), disabled }
            }
          },
        ],
        commonOperate: {
          add: true,
          update: true
        }
      }
    }
  };
}

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  exportByDealerType: {
    path: `${componentName}/exportByDealerType`,
    payload: {
      key: `${componentName}@exportByDealerType`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
